import { useRef, useState } from 'react';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectFirstSection } from 'components/editor/grid/reduxStore/editorSlice';
import type { SectionStyles } from 'components/editor/Sections/Section.model';
import { useSectionStylesUpdate } from './useSectionStylesUpdate';

export function useSectionBackgroundPreview() {
  const firstSection = useAppSelector(selectFirstSection);
  const sectionId = firstSection?.id ?? '';
  const reduxSectionStyles: SectionStyles = (firstSection?.styles ?? {}) as SectionStyles;
  const { updateStyles } = useSectionStylesUpdate(sectionId);
  const [previewSectionStylesState, setPreviewSectionStylesState] = useState<Partial<SectionStyles> | null>(null);
  const capturedSectionStylesRef = useRef<SectionStyles>({});

  const sectionStyles: SectionStyles = previewSectionStylesState
    ? { ...reduxSectionStyles, ...previewSectionStylesState }
    : reduxSectionStyles;

  const captureSectionStyles = () => {
    capturedSectionStylesRef.current = { ...reduxSectionStyles };
  };

  const previewSectionBackgroundColor = (color: string) => {
    setPreviewSectionStylesState((prev) => ({ ...prev, backgroundColor: color }));
  };

  const commitSectionBackgroundColor = (color: string) => {
    setPreviewSectionStylesState(null);
    if (!sectionId || capturedSectionStylesRef.current.backgroundColor === color) return;
    updateStyles({ ...reduxSectionStyles, backgroundColor: color });
  };

  return { sectionStyles, previewSectionBackgroundColor, captureSectionStyles, commitSectionBackgroundColor };
}
